import { schema } from "normalizr";

const billingPaymentMethod = new schema.Entity(`billingPaymentMethod`);

export default billingPaymentMethod;
